import { render } from "./GridTargetPeUserCRM.vue?vue&type=template&id=380c8b80&scoped=true&ts=true"
import script from "./GridTargetPeUserCRM.vue?vue&type=script&lang=ts"
export * from "./GridTargetPeUserCRM.vue?vue&type=script&lang=ts"

import "./GridTargetPeUserCRM.vue?vue&type=style&index=0&id=380c8b80&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380c8b80"]])

export default __exports__